import { BASE_URL } from '../../../../sitemap-pages';

const RUSS_PERSON_ID = `${BASE_URL}/about/bio#russ-rodgers`;

/**
 * Canonical Person schema for Russ Rodgers, used by ProfilePage on the bio
 * route. The `@id` lets future schemas (e.g. BlogPosting.author) reference
 * this same Person via `{ '@id': RUSS_PERSON_ID }` instead of duplicating
 * the full description across pages.
 *
 * Previously lived in the eagerly-imported `seo-profile.ts` (app.routes.ts
 * called `createBioProfilePage()` from its static route data), which put
 * this Person node's ~1.2kB in every page's initial bundle even though it
 * is only ever used on /about/bio. Moved here 2026-09-14 so it's set at
 * runtime via SEOService — see BioContentComponent — inside this route's
 * own lazy chunk, following the testimonials-jsonld.ts precedent.
 */
export const RUSS_PERSON: Readonly<Record<string, unknown>> = {
  '@type': 'Person',
  '@id': RUSS_PERSON_ID,
  name: 'Russ Rodgers',
  alternateName: 'Russell Rodgers',
  jobTitle: 'Bass Guitar Instructor',
  description:
    'Veteran bassist and educator with over five decades of professional performance and instructional experience. Founded the Bass Program at the Atlanta Institute of Music in 1985 and served as its Director for eight years.',
  url: `${BASE_URL}/about/bio`,
  image: `${BASE_URL}/images/russ-bio-image.webp`,
  sameAs: [
    'https://www.facebook.com/russrodgersbassguitar/',
    'https://www.instagram.com/russbassrodgers/',
    'https://www.youtube.com/@RussellRodgers',
    'https://www.linkedin.com/in/russ-rodgers-3724904/',
  ],
  worksFor: {
    '@type': 'EducationalOrganization',
    name: 'Russ Rodgers Bass Guitar Instruction',
    url: BASE_URL,
  },
  knowsAbout: [
    'Bass guitar',
    'Music theory',
    'Jazz bass',
    'Online bass lessons',
    'Bass technique',
  ],
};

/**
 * Full JSON-LD schema array for /about/bio: a single ProfilePage wrapping
 * RUSS_PERSON. Set at runtime via SEOService.setRouteSchemas (see
 * BioContentComponent) rather than the route's static data.seo.jsonLd.
 *
 * Order/position: e2e/data/pages.ts's bio `schemas` expectation is
 * `['BreadcrumbList', 'ProfilePage']` — BreadcrumbList still comes from
 * static route data (see SEOService.getRouteBreadcrumbs), unaffected by
 * this override.
 */
export function buildBioPageSchemas(): Record<string, unknown>[] {
  return [
    {
      '@type': 'ProfilePage',
      mainEntity: RUSS_PERSON,
    },
  ];
}
